(() => {
  const selector = '[data-scroll-down]';
  const buttonScroll = document.querySelector(selector);

  if (buttonScroll) {
    buttonScroll.addEventListener('click', () => {
      smoothScroll();
    }, false);

    buttonScroll.addEventListener('keyup', event => {
      if (event.keyCode === 13) {
        smoothScroll();
      }
    }, false);
  }

  const smoothScroll = () => {
    window.scroll({
      top: document.body.offsetHeight,
      left: 0,
      behavior: 'smooth'
    });
  }

  const chars = [
    'é',
    'â',
    'ï',
    'ù',
    'з',
    'д',
    'й',
    'п',
    'и',
    'ь',
    '创',
    '造',
    'C',
    'r',
    'e',
    'a',
    't',
    'e',
    'T',
    'r',
    'a',
    'n',
    's',
    'l',
    'a',
    't',
    'e',
    'D',
    'e',
    'l',
    'i',
    'v',
    'e',
    'r'
  ];

  const getRandomChar = chars => chars[Math.floor(Math.random() * chars.length)];
  const getChar = (i, j, maxLength, oldResult, newline, chars) => {
    if (j > i) {
      return oldResult[j];
    }

    if (i >= maxLength && j < i - maxLength) {
      return newline[j];
    }

    return getRandomChar(chars);
  };

  const oneScrambler = textarrayScrambler => {
    const textStrings = JSON.parse(textarrayScrambler.dataset.text);
    let stringId = 0;
    let result = '';
    let intervalRef = null;
    let timerRef = null;
    let delayRef = null;
    let speed = parseFloat(textarrayScrambler.dataset.speed) || 37.5;
    let delay = parseFloat(textarrayScrambler.dataset.delay) || 5;
    let timeOut = parseFloat(textarrayScrambler.dataset.timeout) || 5;

    const setResult = (value) => result = value;

    const animate = stringId => {
      let i = 0;
      let line = textStrings[stringId];
      let nextLineId = stringId < textStrings.length - 1 ? ++stringId : stringId = 0;

      intervalRef = setInterval(() => {
        if (result === line) {
          clearInterval(intervalRef);

          timerRef = setTimeout(() => {
            animate(nextLineId);
            clearTimeout(timerRef);
          }, delay * 1000);

          setResult(line);
        }

        const oldLength = result ? result.length : 0;
        const newLength = line.length;
        const maxLength = Math.max(oldLength, newLength);

        textarrayScrambler.innerHTML = result;

        setResult([...new Array(maxLength)]
          .map((_, j) => getChar(i, j, maxLength, result, line, chars))
          .join(''));
        i++;
      }, speed);
    }

    const initTextScramble = () => {
      clearInterval(intervalRef);
      clearTimeout(timerRef);
      clearTimeout(delayRef);

      setResult(textStrings[0]);
      textarrayScrambler.innerHTML = result;

      if (window.innerWidth >= 600) {
        delayRef = setTimeout(() => {
          stringId = stringId < textStrings.length - 1 ? ++stringId : stringId = 0;
          animate(stringId);
          clearTimeout(delayRef);
        }, timeOut * 1000);
      } else {
        textarrayScrambler.innerHTML = textStrings[0];
      }
    };

    initTextScramble();

    let resetTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resetTimeout);
      resetTimeout = setTimeout(initTextScramble, 100);
    });
  }

  const textarrayScramblers = document.querySelectorAll('[data-textarray-scrambler]');
  if (textarrayScramblers.length > 0) {
    textarrayScramblers.forEach(textarrayScrambler => {
      oneScrambler(textarrayScrambler);
    });
  }


  const textScramblers = document.querySelectorAll('[data-text-scrambler]');
  if (textScramblers.length > 0) {
    textScramblers.forEach(textScrambler => {
      const text = textScrambler.dataset.text;
      const alternate = textScrambler.dataset.alternate;
      let result = '';
      let intervalRef = null;
      let timerRef = null;
      let delayRef = null;
      let speed = parseFloat(textScrambler.dataset.speed) || 37.5;
      let delay = parseFloat(textScrambler.dataset.delay) || 5;
      let timeOut = parseFloat(textScrambler.dataset.timeout) || 5;
      const setResult = (value) => result = value;
      const animate = line => {
        let i = 0;

        intervalRef = setInterval(() => {
          if (result === line) {
            clearInterval(intervalRef);

            if (alternate) {
              timerRef = setTimeout(() => {
                animate(line === text ? alternate : text);
                clearTimeout(timerRef);
              }, delay * 1000);
            }

            setResult(line);
          }

          const oldLength = result ? result.length : 0;
          const newLength = line.length;
          const maxLength = Math.max(oldLength, newLength);

          textScrambler.innerHTML = result;

          setResult([...new Array(maxLength)]
            .map((_, j) => getChar(i, j, maxLength, result, line, chars))
            .join(''));
          i++;
        }, speed);
      }

      const initTextScramble = () => {
        clearInterval(intervalRef);
        clearTimeout(timerRef);
        clearTimeout(delayRef);

        setResult(text);
        textScrambler.innerHTML = result;

        if (window.innerWidth >= 600) {
          delayRef = setTimeout(() => {
            animate(alternate);
            clearTimeout(delayRef);
          }, timeOut * 1000);
        } else {
          textScrambler.innerHTML = text;
        }
      };

      initTextScramble();

      let resetTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resetTimeout);
        resetTimeout = setTimeout(initTextScramble, 100);
      });
    });
  }
})();
